module.exports = __webpack_public_path__ + "static/img/scump.d323e1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/scump.jpg
// module id = Tig5
// module chunks = 35